import type { ScheduleStats as Stats } from '../utils/schedule-board'

function StatCard({ label, value, extra, alert }: { label: string; value: number; extra?: string; alert?: { bg: string; border: string; ink: string } | null }) {
  return (
    <div
      className="rounded-[14px] border px-[18px] py-3"
      style={alert ? { background: alert.bg, borderColor: alert.border, color: alert.ink } : { background: '#FFFFFF', borderColor: '#DDE4DC', color: '#14231B' }}
    >
      <p className="text-[13px] font-semibold" style={alert ? undefined : { color: '#4A5A51' }}>{label}</p>
      <p className="mt-0.5 flex flex-wrap items-baseline gap-x-2">
        <span className="text-[28px] font-bold leading-tight tabular-nums">{value}</span>
        {extra ? <span className="text-[13px] text-[#4A5A51]">{extra}</span> : null}
      </p>
    </div>
  )
}

/** Jobs / Need a worker / Problems / On shift, from the same rules as the grid and panel. */
export function ScheduleStats({ stats, onShiftLabel }: { stats: Stats; onShiftLabel: string }) {
  return (
    <section className="grid grid-cols-2 gap-3 lg:grid-cols-4" aria-label="Summary">
      <StatCard label="Jobs this week" value={stats.jobs} />
      <StatCard
        label="Need a worker"
        value={stats.needWorker}
        alert={stats.needWorker ? { bg: '#FFF4D6', border: '#F0D58A', ink: '#5E3C00' } : null}
      />
      <StatCard
        label="Leave, clash or hours problems"
        value={stats.problems}
        alert={stats.problems ? { bg: '#FDECEA', border: '#F3B8B2', ink: '#8A1C12' } : null}
      />
      <StatCard label={onShiftLabel} value={stats.onShift} extra={`of ${stats.totalWorkers}`} />
    </section>
  )
}
